import { jsx } from "react/jsx-runtime";
import { useRef, useEffect } from "react";
import { InputAdornment } from "@mui/material";
import { useLocalStorageProperly } from "../../../../../../hooks/useLocalStorageProperly.js";
import { SearchInputWrapper, SearchInput, SearchIcon } from "./practitioner-search.styles.js";
import "@mui/material/styles";
import "./assets/Search.js";
const PractitionerSearch = ({ onSearch, placeholder, clinicReferenceId }) => {
  const [searchValue, setSearchValue] = useLocalStorageProperly(
    `${clinicReferenceId}_PractitionerSearchValue`,
    ""
  );
  const inputRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      var _a;
      (_a = inputRef.current) == null ? void 0 : _a.focus();
    }, 300);
  }, [searchValue]);
  useEffect(() => {
    if (searchValue) {
      onSearch(searchValue);
    }
  }, []);
  return /* @__PURE__ */ jsx(SearchInputWrapper, { children: /* @__PURE__ */ jsx(
    SearchInput,
    {
      onKeyDown: (e) => {
        e.stopPropagation();
      },
      onChange: (e) => {
        setSearchValue(e.target.value);
        onSearch(e.target.value);
      },
      fullWidth: true,
      inputRef,
      value: searchValue,
      placeholder,
      InputProps: {
        startAdornment: /* @__PURE__ */ jsx(InputAdornment, { position: "start", children: /* @__PURE__ */ jsx(SearchIcon, {}) })
      },
      variant: "outlined"
    }
  ) });
};
export {
  PractitionerSearch
};
